/* DRYON native theme enhancements. Purchasing remains usable without JavaScript. */
(() => {
  document.documentElement.classList.add('commerce-enhanced');
  const initialized = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-product-panel]').forEach(panel => {
      if (initialized.has(panel)) return;
      initialized.add(panel);
      panel.querySelectorAll('[data-variant-select]').forEach(select => {
        select.addEventListener('change', () => select.form.requestSubmit());
      });
      const form = panel.querySelector('.native-product-form');
      if (form) {
        const quantity = form.querySelector('[name="quantity"]');
        const stepButtons = [...form.querySelectorAll('[data-quantity-step]')];
        const syncQuantity = (value = quantity.valueAsNumber) => {
          const min = Number(quantity.min) || 1;
          const step = Number(quantity.step) || 1;
          const rawMax = quantity.max ? Number(quantity.max) : Infinity;
          const max = Number.isFinite(rawMax) ? min + Math.floor((rawMax - min) / step) * step : Infinity;
          const next = Math.min(max, Math.max(min, min + Math.round(((Number.isFinite(value) ? value : min) - min) / step) * step));
          quantity.value = String(next);
          stepButtons.forEach(button => {button.disabled = Number(button.dataset.quantityStep) < 0 ? next <= min : next >= max;});
        };
        if (quantity) {
          stepButtons.forEach(button => button.addEventListener('click', () => syncQuantity(quantity.valueAsNumber + Number(button.dataset.quantityStep) * (Number(quantity.step) || 1))));
          quantity.addEventListener('change', () => syncQuantity());
          syncQuantity();
        }
        const button = form.querySelector('[name="add"]');
        const note = form.querySelector('#ordering-note');
        let submitting = false, navigating = false;
        const label = button?.textContent;
        const unlock = () => {
          submitting = false;navigating = false;
          if (button) {button.disabled = false;button.textContent = label;}
          form.removeAttribute('aria-busy');
        };
        const onPageShow = event => {
          if (event.persisted && navigating) {
            unlock();
            note.textContent = 'Check your cart before adding this item again.';
          }
        };
        window.addEventListener('pageshow', onPageShow);
        panel.addEventListener('dryon:cleanup', () => window.removeEventListener('pageshow', onPageShow), {once:true});
        form.addEventListener('submit', async event => {
          if (!button || button.disabled || submitting) {event.preventDefault();return;}
          if (!form.reportValidity()) {event.preventDefault();return;}
          const endpoint = new URL(form.action, location.href);
          // Never forward customer input or cart mutations outside this storefront.
          if (endpoint.origin !== location.origin) {event.preventDefault();return;}
          event.preventDefault();submitting = true;button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          button.textContent = 'Adding…';
          note.textContent = 'Adding to your cart…';
          try {
            endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
            const response = await fetch(endpoint, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'},credentials:'same-origin'});
            const result = await response.json();
            if (!response.ok) {
              note.textContent = typeof result.description === 'string' ? result.description : 'This item could not be added. Please review the quantity and availability.';
              return;
            }
            if (!result.id && !Array.isArray(result.items)) throw new Error('Unexpected cart response');
            const checkout = form.querySelector('[name="return_to"]')?.value;
            if (!checkout) throw new Error('Missing checkout route');
            const target = new URL(checkout, location.href);
            const expectedPath = endpoint.pathname.replace(/\/cart\/add\.js$/, '/checkout');
            if (target.origin !== location.origin || target.pathname !== expectedPath || target.search || target.hash || target.username || target.password) throw new Error('Invalid checkout route');
            // assign schedules navigation; the current document can still receive clicks.
            navigating = true;
            button.textContent = 'Added to cart';
            note.textContent = 'Added to your cart. Opening checkout… Use the Cart link if navigation is interrupted.';
            location.assign(target.href);
          } catch {
            navigating = false;
            // Do not automatically retry a mutation: it may have succeeded server-side.
            note.textContent = 'We could not confirm the cart update. Check your cart before trying again.';
          } finally {
            if (!navigating) unlock();
          }
        });
      }
      const bar = panel.parentElement.querySelector('.mobile-buy-bar');
      if (bar) {
        let inView = false, buyVisible = false;
        const sync = () => {const root=document.documentElement;const visible=inView&&(!root.classList.contains('enhanced')||root.classList.contains('in-shop'));bar.hidden=!visible||buyVisible;root.classList.toggle('shop-visible',visible);};
        const observer = new IntersectionObserver(entries => {inView=entries[0].isIntersecting;sync();});
        const buyObserver = new IntersectionObserver(entries => {buyVisible=entries[0].isIntersecting;sync();});
        observer.observe(panel);
        const buyPanel=panel.querySelector('#buy-panel');if(buyPanel)buyObserver.observe(buyPanel);
        window.addEventListener('dryon:chapter',sync);
        panel.addEventListener('dryon:cleanup',()=>{observer.disconnect();buyObserver.disconnect();window.removeEventListener('dryon:chapter',sync);},{once:true});
      }
    });
  }
  function openDetail() {const target=document.getElementById(location.hash.slice(1));if(target instanceof HTMLDetailsElement)target.open=true;}
  init();openDetail();window.addEventListener('hashchange',openDetail);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-product-panel]').forEach(panel=>panel.dispatchEvent(new Event('dryon:cleanup'))));
})();
